import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { hasPermission } from '../helpers/subscription.helpers';

const hasAnyPermission = (access, permissions) => permissions.some((perm) => hasPermission(access, perm));

const PermissionGuard = ({ access, synced, permissions, children }) => {
  const location = useLocation();

  if (!synced) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#f5f5f5',
        }}
      >
        <div className="text-center">
          <div className="spinner-border text-success" role="status" />
          <p className="mt-3 text-muted mb-0">Checking module access...</p>
        </div>
      </div>
    );
  }

  if (!Array.isArray(permissions) || permissions.length === 0 || hasAnyPermission(access, permissions)) {
    return children;
  }

  return <Redirect to={{ pathname: '/choosetype', state: { from: location } }} />;
};

PermissionGuard.propTypes = {
  access: PropTypes.object,
  synced: PropTypes.bool,
  permissions: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node.isRequired,
};

PermissionGuard.defaultProps = {
  access: null,
  synced: false,
  permissions: [],
};

const mapStateToProps = (state) => ({
  access: state.subscription.access,
  synced: state.subscription.synced,
});

export default connect(mapStateToProps)(PermissionGuard);
